import { WatermarkElementTypes, type IWatermarkSet } from '@/types/watermarks.types';

export const withSortedElements = (watermark: IWatermarkSet) => {
  return {
    ...watermark,
    elements: watermark.elements.toSorted((a) => {
      return a.type === WatermarkElementTypes.image ? 1 : -1;
    }),
  };
};
